<div class="ion-margin-start">
  <h1>Piano di Cura Avanzato</h1>

  <ion-note>
    Configura le funzionalità più avanzate del piano di cura del il paziente disponibili nelle
    sezioni disponibili qua sotto
  </ion-note>
</div>

<ion-grid class="ion-margin-top" *ngIf="!currentShownConfigs">
  <ion-row>
    <ion-col class="c3-flex ion-align-items-center ion-justify-content-center">
      <ion-icon size="large" color="secondary" [src]="'information-outline' | getIcon"> </ion-icon>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col class="c3-flex ion-align-items-center ion-justify-content-center">
      <p>In questa sezione non è presente alcuna configurazione disponibile</p>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-grid class="ion-margin-top">
  <ion-row>
    <ion-col size="12" *ngIf="showConfig('app-features')" id="anchor-app-features">
      <c3-config-app-features #configSection> </c3-config-app-features>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('pdta')" id="anchor-pdta">
      <app-config-pdta> </app-config-pdta>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('anamnesi')" id="anchor-anamnesi">
      <app-config-diario-anamnesi></app-config-diario-anamnesi>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('surveys')" id="anchor-surveys">
      <c3-config-surveys #configSection> </c3-config-surveys>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('personal-experiments')" id="anchor-personal-experiments">
      <c3-config-personal-experiments #configSection> </c3-config-personal-experiments>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('goals')" id="anchor-goals">
      <c3-config-goals #configSection> </c3-config-goals>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('education-ondemand')" id="anchor-edu-ondemand">
      <c3-config-edu-ondemand #configSection> </c3-config-edu-ondemand>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('education-contextual')" id="anchor-warnings-patient">
      <c3-config-warnings-patient #configSection> </c3-config-warnings-patient>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('microlearning')" id="anchor-microlearning">
      <c3-config-microlearning #configSection> </c3-config-microlearning>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('predictive-models')" id="anchor-predictive-models">
      <c3-config-predictive-models #configSection> </c3-config-predictive-models>
    </ion-col>

    <ion-col size="12" *ngIf="showConfig('questionnaires')" id="anchor-questionnaires">
      <app-config-questionnaires #configSection> </app-config-questionnaires>
    </ion-col>
  </ion-row>
</ion-grid>
